/* Calendar-based Christmas delivery estimate; no visitor-specific deadlines. */
(() => {
  const DAY = 86400000;
  function calendarDays(value, fallback, maximum) {
    const number = Number(value);
    return Number.isFinite(number) && number >= 0 ? Math.min(maximum, Math.floor(number)) : fallback;
  }
  function dateInZone(now, timeZone) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone, year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now);
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    return Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day));
  }
  function holidayState(now, settings) {
    const today = dateInZone(now, settings.timeZone || 'America/New_York');
    const christmas = Date.UTC(new Date(today).getUTCFullYear(), 11, 25);
    const arrival = today + calendarDays(settings.delivery, 15, 60) * DAY;
    return {today, arrival, days: Math.max(0, Math.round((christmas - arrival) / DAY)),
      closed: arrival >= christmas, christmasDay: today === christmas, expired: today > christmas};
  }
  if (window.cozyChristmasLoaded) return;
  window.cozyChristmasLoaded = true;
  const dateFormat = new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'
  });
  function render() {
    document.querySelectorAll('[data-cozy-christmas]').forEach(card => {
      const state = holidayState(new Date(), {
        delivery: card.dataset.deliveryDays,
        timeZone: 'America/New_York'
      });
      card.hidden = state.expired;
      if (state.expired) return;
      const date = card.querySelector('[data-holiday-date]');
      date.textContent = dateFormat.format(new Date(state.today));
      date.dateTime = new Date(state.today).toISOString().slice(0, 10);
      card.querySelector('[data-holiday-order]').hidden = state.closed;
      const late = card.querySelector('[data-holiday-late]');
      late.hidden = !state.closed;
      late.textContent = state.christmasDay ? card.dataset.christmasMessage : card.dataset.lateMessage;
      card.querySelector('[data-holiday-days]').textContent = String(state.days);
      card.querySelector('[data-holiday-count]').hidden = state.closed;
    });
  }
  render();
  setInterval(render, 60000);
  document.addEventListener('shopify:section:load', render);
  document.addEventListener('visibilitychange', () => {if (!document.hidden) render();});
  window.addEventListener('pageshow', render);
})();
